/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

const clientId = process.env.B2C_CLIENT_ID
const scopesBaseUrl = process.env.B2C_SCOPES_BASE_URL
const authorityDomain = process.env.B2C_AUTHORITY_DOMAIN_URL

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */

export const b2cPolicies = {
  names: {
    signupSignin: process.env.B2C_SIGNUP_SIGNIN_NAME,
    resetPassword: process.env.B2C_RESET_PASSWORD_NAME,
    editProfile: process.env.B2C_EDIT_PROFILE_NAME,
  },
  authorities: {
    signupSignin: {
      authority: process.env.B2C_SIGNUP_SIGNIN_URL,
    },
    resetPassword: {
      authority: process.env.B2C_RESET_PASSWORD_URL,
    },
    editProfile: {
      authority: process.env.B2C_EDIT_PROFILE_URL,
    },
  },
  authorityDomain,
}

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
  auth: {
    clientId, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signupSignin.authority, // Choose SS as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  freeriders: {
    scopes: [`${scopesBaseUrl}/${clientId}/Freeriders.All`],
  },
  reservations: {
    scopes: [`${scopesBaseUrl}/${clientId}/Reservations.All`],
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.freeriders.scopes, ...protectedResources.reservations.scopes],
}
